import React from 'react';
import MonthProgress from "../../Molecules/MonthProgress";
import MonthProgressEmptyState from "../Emptys/MonthProgressEmptyState";
import Container from "../../Wrappers/Container";

const DashboardProgress = () => {


  return (
    <Container>
      <h3>Progreso de noviembre</h3>

      <MonthProgress/>

      {/*<MonthProgressEmptyState/>*/}
    </Container>
  )

};

export default DashboardProgress;
